@if(!data){
<code>...</code>
}
@else{
<div aria-label="Error messages">
  @for( msg of data; track $index){
  <div>{{ msg }}</div>
  }
</div>
}
